/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Maintenance_BodyInputs */

const tr_mesafeli_s12_maintenance_body = /** @type {(inputs: Mesafeli_S12_Maintenance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en az 72 saat önceden e-posta ve Platform içi bildirim ile duyurulur.`)
};

const en_mesafeli_s12_maintenance_body = /** @type {(inputs: Mesafeli_S12_Maintenance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`announced at least 72 hours in advance by email and by in-Platform notification.`)
};

const de_mesafeli_s12_maintenance_body = /** @type {(inputs: Mesafeli_S12_Maintenance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wird mindestens 72 Stunden im Voraus per E-Mail und über eine Benachrichtigung in der Plattform angekündigt.`)
};

const ru_mesafeli_s12_maintenance_body = /** @type {(inputs: Mesafeli_S12_Maintenance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`объявляются не менее чем за 72 часа по электронной почте и через уведомление в Платформе.`)
};

/**
* | output |
* | --- |
* | "announced at least 72 hours in advance by email and by in-Platform notification." |
*
* @param {Mesafeli_S12_Maintenance_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_maintenance_body = /** @type {((inputs?: Mesafeli_S12_Maintenance_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Maintenance_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_maintenance_body(inputs)
	if (locale === "de") return de_mesafeli_s12_maintenance_body(inputs)
	if (locale === "ru") return ru_mesafeli_s12_maintenance_body(inputs)
	return tr_mesafeli_s12_maintenance_body(inputs)
});